import { render } from "./CloseIcon.vue?vue&type=template&id=09660684&scoped=true"
const script = {}

import "./CloseIcon.vue?vue&type=style&index=0&id=09660684&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09660684"]])

export default __exports__